import { createAction, createSlice } from '@reduxjs/toolkit';
import {
    SET_TIMER_CURRENT_ID,
    SET_TIMER_CURRENT_TIME,
} from '../../common/actions/SurveyTimerActions';
import { GET_ACTIVE_QUESTIONNAIRES_SUCCESS } from '../../constants/actions/users.constants';
import { LOGOUT } from '../../constants/actions/auth.constants';
import QuestionnaireActions from '../../participant/actions/QuestionnaireActions';

const setTimerCurrentId = createAction<number | null>(SET_TIMER_CURRENT_ID);
const setTimerCurrentTime = createAction<number>(SET_TIMER_CURRENT_TIME);
const getActiveQuestionnairesSuccess = createAction<
    Array<{
        id?: number;
        sections?: Array<{
            subsections?: Array<{ remainingTime?: number }>;
        }>;
    }>
>(GET_ACTIVE_QUESTIONNAIRES_SUCCESS);

const NAME = 'surveyTimer';

export type SurveyTimerState = {
    currentId: number | null;
    time: number;
};

const initialState: SurveyTimerState = {
    currentId: null,
    time: 0,
};

const slice = createSlice({
    name: NAME,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(setTimerCurrentId, (state, action) => {
                state.currentId = action.payload;
            })
            .addCase(setTimerCurrentTime, (state, action) => {
                state.time = action.payload;
            })
            .addCase(getActiveQuestionnairesSuccess, (state, action) => {
                const payload = action.payload;
                state.currentId = payload?.[0]?.id ?? null;
                state.time =
                    payload?.[0]?.sections?.[0]?.subsections?.[0]
                        ?.remainingTime ?? 0;
            })
            .addCase(QuestionnaireActions.closeQuestionnaire.type, () => ({
                currentId: null,
                time: 0,
            }))
            .addCase(LOGOUT, () => initialState);
    },
});

export default { reducer: slice.reducer, actions: slice.actions };
